import { axios } from '@/utils/request'
const api = {
  rechargeList: '/admin.php/order/rechargeList',
  rechargeDetail: '/admin.php/order/rechargeDetail',
  cancelOrder: '/admin.php/order/cancel',
  addExpress: '/admin.php/order/addExpress',
  annualList: '/admin.php/order/annualList',
  annualDetail: '/admin.php/order/annualDetail',
  printList: '/admin.php/order/printList/',
  printDetail: '/admin.php/order/printDetail',
  orderPre: '/admin.php/order/pre/',
  printIndex: '/admin.php/printer/index'
}
// 充值订单列表
export function getRechargeList (parameter) {
  return axios({
    url: api.rechargeList,
    method: 'get',
    params: parameter
  })
}
// 充值订单详情
export function getRechargeDetail (parameter) {
  return axios({
    url: api.rechargeDetail,
    method: 'get',
    params: parameter
  })
}
// 打印订单列表
export function getPrintList(parameter) {
  return axios({
    url: api.printList,
    method: 'get',
    params: parameter
  })
}
// 打印订单详情
export function getPrintDetail (parameter) {
  return axios({
    url: api.printDetail,
    method: 'get',
    params: parameter
  })
}
// 取消订单
export function cancelOrder (parameter) {
  return axios({
    url: api.cancelOrder,
    method: 'post',
    data: parameter
  })
}
// 填写物流单号
export function addExpress (parameter) {
  return axios({
    url: api.addExpress,
    method: 'post',
    data: parameter
  })
}
// 年费订单列表
export function annualList (parameter) {
  return axios({
    url: api.annualList,
    method: 'get',
    params: parameter
  })
}
// 年费订单详情
export function annualDetail (parameter) {
  return axios({
    url: api.annualDetail,
    method: 'get',
    params: parameter
  })
}

// 预加载
export function orderPre (parameter) {
  return axios({
    url: api.orderPre,
    method: 'get',
    params: parameter
  })
}

// 打印
export function printIndex (parameter) {
  return axios({
    url: api.printIndex,
    method: 'post',
    data: parameter
  })
}
